import React from "react";
import { CaretLeft, CaretRight, CalendarBlank } from "@phosphor-icons/react";
import { currentMonth, monthLabel, shiftMonth } from "./monthUtils";

export const MonthNav = ({ month, onChange }) => {
  const isCurrent = month === currentMonth();
  const btn = "h-9 w-9 inline-flex items-center justify-center border-2 border-zinc-900 bg-white hover:bg-zinc-900 hover:text-white transition-colors disabled:opacity-30 disabled:hover:bg-white disabled:hover:text-zinc-900";
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="fuel-month-nav">
      <button className={btn} onClick={() => onChange(shiftMonth(month, -1))} data-testid="fuel-month-prev" aria-label="Mois précédent">
        <CaretLeft weight="bold" />
      </button>
      <div className="h-9 px-4 min-w-[190px] inline-flex items-center justify-center gap-2 border-2 border-zinc-900 bg-zinc-900 text-white text-sm font-bold uppercase tracking-widest" data-testid="fuel-month-label">
        <CalendarBlank size={14} weight="bold" /> {monthLabel(month)}
      </div>
      <button className={btn} onClick={() => onChange(shiftMonth(month, 1))} disabled={isCurrent} data-testid="fuel-month-next" aria-label="Mois suivant">
        <CaretRight weight="bold" />
      </button>
      {!isCurrent && (
        <button onClick={() => onChange(currentMonth())} className="h-9 px-3 text-[10px] font-bold uppercase tracking-widest border border-zinc-300 hover:border-zinc-900 transition-colors" data-testid="fuel-month-current">
          Mois en cours
        </button>
      )}
    </div>
  );
};
